import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 3 * 60 * 1000, // request timeout
  headers: { 'X-Requested-With': 'XMLHttpRequest' } // 加入这个请求头后台服务可以判断是ajax请求
})

// request interceptor
service.interceptors.request.use(config => {
  // Do something before request is sent
  if (store.getters.token) {
    config.headers['Authorization'] = 'Bearer' + getToken() // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
  response => {
  /**
  * 下面的注释为通过response自定义success来标示请求状态，当success返回如下情况为权限有问题，登出并返回到登录页
  * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
  */
    const res = response.data
    if (res.success == null || res.success === '') {
      // 数据体结构错误
      Message({ message: '请检查数据结构，后台结果集必须用Result来封装', type: 'error', duration: 5 * 1000 })
      return Promise.reject('error')
    } else if (res.success === true || res.success === false) {
      // 后台返回业务数据逻辑正常/后台返回业务数据逻辑失败
      if (!res.success) {
        // 返回失败时进行提示
        Message({ message: res.msg, type: 'error', duration: 5 * 1000 })
      }
      return response
    } else if (res.success === 'noLogin') {
      // 登录已经超时或未登录
      MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
        confirmButtonText: '重新登录', cancelButtonText: '取消', type: 'warning'
      }).then(() => {
        store.dispatch('LogOut').then(() => {
          // 为了重新实例化vue-router对象 避免bug
          location.reload()
        })
      })
    } else {
      // success为匹配上后台定义的规则
      Message({ message: 'success:' + res.success + '未定义', type: 'error', duration: 5 * 1000 })
      return Promise.reject('error')
    }
  },
  error => {
    console.log('err' + error)// for debug
    Message({ message: error.message, type: 'error', duration: 5 * 1000 })
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js